// extracted by mini-css-extract-plugin
module.exports = {"container":"Erp_container__2zBZo","title":"Erp_title__3Z6-R","bg_color":"Erp_bg_color__1wv87","confirm":"Erp_confirm__1pLv5","radio":"Erp_radio__3aqbZ"};